import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
);

const createGradient = (ctx, area, color) => {
    const gradient = ctx.createLinearGradient(0, area.bottom, 0, area.top);
    gradient.addColorStop(0, color + '22');
    gradient.addColorStop(1, color + '99');
    return gradient;
};

export default class AreaChartTemplate2 extends React.Component {
    render() {
        const {
            graphData,
            colors,
            xLabel,
            yLabel,
            layoutItem
        } = this.props;
        const reportConfig = layoutItem && layoutItem.itemProperties && layoutItem.itemProperties.reportConfig

        const { externalUrl, targetProperty } = reportConfig

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
                mode: 'nearest',
                intersect: false,
            },

            events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],

            onClick: (event, elements) => {
                if (!elements.length) return;


                if (externalUrl && targetProperty) {
                    const index = elements[0].index;
                    const clickedStockData = graphData[index];
                    if (!clickedStockData) return;

                    let str = targetProperty.replace('{{', '').replace('}}', '');
                    const prefix = '__ADDITIONAL_MODEL_DATA.';

                    if (str.startsWith(prefix)) {
                        str = str.replace(/^__ADDITIONAL_MODEL_DATA\.[^.]+\./, '');
                    }

                    if (clickedStockData.xProperties) {
                        const baseUrl = window.location.origin;
                        const redirectUrl =
                            baseUrl +
                            '/app/' +
                            externalUrl +
                            '?ct=' +
                            str +
                            ':' +
                            clickedStockData.xProperties;

                        window.location.href = redirectUrl;
                    }
                }
            },

            onHover: (event, elements) => {
                event.native.target.style.cursor = elements.length
                    ? 'pointer'
                    : 'default';
            },

            animation: {
                duration: 1000,
                easing: 'easeOutQuart',
            },

            plugins: {
                legend: {
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                        padding: 16,
                        font: { size: 12 },
                    },
                },
                tooltip: {
                    backgroundColor: '#111827',
                    padding: 12,
                    cornerRadius: 10,
                },
                title: {
                    display: true,
                    text: yLabel,
                    font: { size: 16, weight: 'bold' },
                },
            },

            scales: {
                x: {
                    grid: { display: false },
                    title: {
                        display: true,
                        text: xLabel,
                        font: { size: 14, weight: 'bold' },
                    },
                },
                y: {
                    grid: {
                        borderDash: [6, 6],
                        color: 'rgba(0,0,0,0.06)',
                    },
                    title: {
                        display: true,
                        text: yLabel,
                        font: { size: 14, weight: 'bold' },
                    },
                },
            },
        };

        const labels = [];
        const yAxisData = [];

        if (graphData && graphData.length) {
            graphData.forEach(item => {
                labels.push(item.xProperties);
                yAxisData.push(item.yProperties);
            });
        }

        const datasets = [
            {
                label: yLabel,
                data: yAxisData,
                fill: true,
                tension: 0.45,
                borderWidth: 2.5,
                borderColor: colors[0],

                pointRadius: 4,
                pointHoverRadius: 6,
                pointHitRadius: 15,

                pointBackgroundColor: '#ffffff',
                pointBorderColor: colors[0],
                pointBorderWidth: 2,

                backgroundColor: (context) => {
                    const chart = context.chart;
                    const ctx = chart.ctx;
                    const chartArea = chart.chartArea;

                    if (!chartArea) {
                        return colors[0] + '33';
                    }
                    return createGradient(ctx, chartArea, colors[0]);
                },
            },
        ];

        return (
            <div
                style={{
                    height: '420px',
                    width: '100%',
                    padding: '16px',
                    background: '#ffffff',
                    borderRadius: '14px',
                }}
            >
                <Line options={options} data={{ labels, datasets }} />
            </div>
        );
    }
}
